// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pF-z","smallCardRow":"qF-z","largeCardRow":"rF-z","productSearchRow":"sF-z","curatedRow":"tF-z"};